import React, { useEffect, useState } from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";
import { getData } from "../../../services/library";

const MotivosModal = ({
  obtenerSolicitudes,
  open,
  onClose,
  mostrarAlertaTemporal,
  id_candidato,
  id_solicitud,
}) => {
  const [motivo, setMotivo] = useState("");
  const [motivosDesplegables, setMotivosDesplegables] = useState([]);
  const [idMotivoSeleccionado, setIdMotivoSeleccionado] = useState(undefined);

  useEffect(() => {
    getData("/SP_motivos_desplegables", (data) => {
      setMotivosDesplegables(Array.isArray(data) ? data : []);
    });
  }, []);

  const motivoSeleccionado = motivosDesplegables.find(
    (motivo) => motivo.id === idMotivoSeleccionado
  );

  useEffect(() => {
    setMotivo(motivoSeleccionado?.valor);
  }, [idMotivoSeleccionado, motivoSeleccionado]);

  const morivosSort = motivosDesplegables?.sort(function (a, b) {
    return a.valor.localeCompare(b.valor);
  });

  const user = localStorage.getItem("user");

  const handleSubmit = async () => {
    logEventos(
      "Eliminado un candidato seleccionado de una solicitud",
      "Solicitud de trabajo",
      "Deseleccionado un candidato de una solicitud",
      localStorage.getItem("user")
    );

    let successPost = false;
    let successPut = false;

    if (motivo?.length === 0) {
      mostrarAlertaTemporal(
        "Completa el campo motivo antes de enviar",
        "error"
      );
      return;
    } else if (motivo?.trim().length < 10) {
      mostrarAlertaTemporal(
        "El motivo debe tener como mínimo 10 caracteres",
        "error"
      );
      return;
    }
    const solicitudMotivo = {
      id_candidato,
      motivo,
      user,
    };
    try {
      const bodyPut = { id: id_solicitud };
      const responsePut = await fetch(
        `${UrlApi}/solicitudDePersonal/deseleccionarCandidato/gg`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyPut),
        }
      );

      if (!responsePut.ok) {
        const errorMessagePut = await responsePut.json();
        mostrarAlertaTemporal(
          errorMessagePut.message || "Ocurrió un error inesperado",
          "error"
        );
      } else {
        successPut = true;
      }
    } catch (err) {
      console.error("Error al realizar la solicitud:", err);
      mostrarAlertaTemporal(
        "Ocurrió un problema. Intente nuevamente.",
        "error"
      );
    }
    try {
      const response = await fetch(`${UrlApi}/SP_motivos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(solicitudMotivo),
      });

      if (!response.ok) {
        const messageError = await response.json();
        mostrarAlertaTemporal(
          messageError.message || "Ocurrió un error inesperado",
          "error"
        );
      } else {
        successPost = true;
      }
    } catch (err) {
      console.error("Error al realizar la solicitud:", err);
      mostrarAlertaTemporal(
        "Ocurrió un problema. Intente nuevamente.",
        "error"
      );
    }
    try {
      const responsePut = await fetch(
        `${UrlApi}/SP_candidatos/${id_candidato}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ estado: 0 }),
        }
      );

      if (!responsePut.ok) {
        const errorMessagePut = await responsePut.json();
        mostrarAlertaTemporal(
          errorMessagePut.message || "Ocurrió un error inesperado",
          "error"
        );
        onClose();
      }
    } catch (err) {
      console.error("Error al realizar la solicitud:", err);
      mostrarAlertaTemporal(
        "Ocurrió un problema. Intente nuevamente.",
        "error"
      );
      onClose();
    }

    if (successPost && successPut) {
      mostrarAlertaTemporal(
        "La solicitud se actualizó correctamente!",
        "success"
      );
      await obtenerSolicitudes();
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="left"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Propuesta rechazada por el candidato
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"left"}>
          <Typography variant="p" align="left" color="#1c1c1c">
            Debe indicar el motivo por el que el candidato decidio rechazar la
            propuesta
          </Typography>
        </DialogContentText>
        <Grid item xs={4}>
          <FormControl fullWidth>
            <InputLabel>
              Motivos recurrentes (Esta opcion reemplazara el texto de abajo)
            </InputLabel>
            <Select
              defaultValue={""}
              onChange={(e) => {
                setIdMotivoSeleccionado(e.target.value);
              }}
              label="Motivos recurrentes"
              sx={{
                maxHeight: "300px",
                overflow: "auto",
                "& .MuiMenu-paper": {
                  maxHeight: "300px", // Altura máxima del menú desplegable
                  overflowY: "auto", // Habilita el scroll si es necesario
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: "300px", // Asegura que el menú tenga scroll si el contenido es largo
                    overflowY: "auto",
                  },
                },
              }}
            >
              {morivosSort?.sort().map((motivo) => (
                <MenuItem
                  key={motivo.id}
                  value={motivo.id}
                  sx={{
                    maxWidth: "700px",
                    whiteSpace: "normal", // Permite que el texto use múltiples líneas
                    wordBreak: "break-word", // Rompe palabras largas
                  }}
                >
                  {motivo.valor}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <TextField
          autoFocus
          margin="dense"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          id="motivo"
          label="Motivo"
          type="text"
          fullWidth
          multiline
          rows={4}
          inputProps={{ maxLength: 300 }}
        />
        <Typography variant="body2" color="textSecondary">
          {motivo?.length || 0} / 300 caracteres
        </Typography>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="end"
          alignItems="center"
          gap={3}
          marginRight={2}
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default MotivosModal;
